<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="90.1 Fabrication Status Control" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnSave'
                ]" @btnRetrieve="btnRetrieve()" @btnSave="btnSave()">
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row dense>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined>
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-2">
                                                    <v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Ship no  : </span>
                                                    <v-col cols="1" class="pl-1">
                                                        <v-autocomplete v-model="selectedShip" :items="shipNoList"
                                                            item-value="selectedShip" label="" return-object single-line
                                                            outlined dense @change="shipNoChange"></v-autocomplete>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Por no : </span>
                                                    <v-col cols="1">
                                                        <v-autocomplete v-model="selectedPor" :items="porList"
                                                            item-value="selectedPor" return-object single-line outlined
                                                            dense :label="'All'" @change="btnRetrieve()"></v-autocomplete>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Block : </span>
                                                    <v-col cols="1">
                                                        <v-autocomplete v-model="selectedBlock" :items="blockList"
                                                            item-value="selectedBlock" return-object single-line outlined
                                                            dense :label="'All'" @change="btnRetrieve()"></v-autocomplete>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Make Status : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="makeSta.select" :items="makeSta.items"
                                                            item-text="name" item-value="cd" return-object single-line
                                                            outlined dense @change="btnRetrieve" ></v-select>
                                                    </v-col>
                                                     <v-icon v-show="locVis" small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                        <span v-show="locVis" class="pa-1 subTitle"> Make Loc : </span>
                                                        <v-col v-show="locVis" cols="2">
                                                            <v-select v-model="makeLoc.select" :items="makeLoc.items"
                                                                item-text="name" item-value="cd" return-object single-line
                                                                outlined dense />
                                                        </v-col>
                                                </v-row>
                                                <v-row dense class="ma-0">
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 pt-2 subTitle">Division : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="div.select" :items="div.items" item-text="name"
                                                            item-value="cd" return-object single-line outlined dense />
                                                    </v-col>
                                                     <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 pt-2 subTitle">Set Date : </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="stDte" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                                                    </v-col>
                                                    <v-btn class="my-1 mx-sm-2" small color="primary" @click="goSetDte()"> Set Date </v-btn>
                                                    <v-btn class="my-1 mx-sm-2" small color="primary" @click="goClearDte()"> Clear Date </v-btn>
                                                    <v-btn class="my-1 mx-sm-2" small color="primary" @click="goDeleteDte()"> Delete All Fab. Date </v-btn>
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epms9010Detail" class="listBox" :ref="epms9010DetailRef"
                                        :data-source="gridMainList" :remote-operations="false" :hover-state-enabled="true"
                                        :allow-column-resizing="true" :allow-column-reordering="true"
                                        :row-alternation-enabled="true" :show-borders="true" :width="grid.width"
                                        :show-row-lines="true" key-expr="id" :focused-row-enabled="false"
                                        :column-hiding-enabled="false" :selection="{ mode: 'none' }"
                                        :sorting="{ mode: 'none' }" :word-wrap-enabled="true" @cellPrepared="cellPrepared" >

                                        <DxColumn data-field="selChek" data-type="boolean" width="5%" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
                                        <template #selHeader = "{ data: cellInfo }" >
                                            <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                                        </template>
                                        <template #selChkRow  = "{ data: cellInfo }">
                                            <DxCheckBox :value="cellInfo.value === 'Y' ? true : false"
                                            :onValueChanged="value => onValueChanged2(value, cellInfo)"
                                            />
                                        </template> 

                                        <DxColumn caption="Ship No" width="12%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" >
                                            <DxColumn data-field="shipNo" caption="Por No" width="12%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn data-field="block" caption="Block" width="7%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn caption="Activity" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" >
                                            <DxColumn data-field="mact" caption="Ser" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Part No" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="partNo" caption="Part Specification" width="10%" data-type="string"
                                                :allow-editing="false" alignment="center" :visible="true"/>
                                        </DxColumn>
                        

                                        <DxColumn caption="Unit" width="7%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="matlUnit" caption="Part Specification" width="7%" data-type="string"
                                                :allow-editing="false" alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Qty" width="7%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="partQty" caption="Part Specification" width="7%" data-type="string"
                                                :allow-editing="false" alignment="center" :visible="true" />
                                        </DxColumn>

                                         <DxColumn caption="U.Wgt" width="8%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="partUnitWgt" caption="Part Specification" width="8%" data-type="string"
                                                :allow-editing="false" alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Material Need Date" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" header-cell-template="matlNeedDte">
                                            <DxColumn data-field="psdDt" caption="Request Date" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"
                                                header-cell-template="reqDte" />
                                        </DxColumn>
                                        <template #matlNeedDte>
                                            <div>Material<br />Need Date</div>
                                        </template>
                                        <template #reqDte>
                                            <div>Request<br />Date</div>
                                        </template>
                                        <DxColumn data-field="distDwgDte" caption="DWG Date" width="12%" data-type="date" format="yyyy-MM-dd"
                                            :allow-editing="true" alignment="center" :visible="true"/>
                                           
                                        <DxColumn  caption="Cutting (MS)" width="12%" data-type="date" format="yyyy-MM-dd"
                                            :allow-editing="true" alignment="center" :visible="true">
                                            <DxColumn data-field="cutDte" caption="Fit-Up" width="12%" data-type="date" format="yyyy-MM-dd"
                                                :allow-editing="true" alignment="center" :visible="true"/>                                           
                                        </DxColumn>

                                        <DxColumn  caption="Welding" width="12%" data-type="date" format="yyyy-MM-dd"
                                                :allow-editing="true" alignment="center" :visible="true">
                                                <DxColumn data-field="weldDte" caption="Grinding (MF)" width="12%" data-type="date" format="yyyy-MM-dd"
                                                    :allow-editing="true" alignment="center" :visible="true"/>                                           
                                        </DxColumn>
                                        
                                        <DxColumn  caption="Shot (PS)" width="12%" data-type="date" format="yyyy-MM-dd"
                                                    :allow-editing="true" alignment="center" :visible="true">
                                                    <DxColumn data-field="stPaintDte" caption="Painting (PF)" width="12%" data-type="date" format="yyyy-MM-dd"
                                                        :allow-editing="true" alignment="center" :visible="true"/>                                           
                                        </DxColumn>

                                        <DxColumn  caption="Sorting Out" width="12%" data-type="date" format="yyyy-MM-dd"
                                                        :allow-editing="true" alignment="center" :visible="true" header-cell-template="sortOutTemplate">
                                                        <DxColumn data-field="sortDte" caption="Ready Stand by" width="12%" data-type="date" format="yyyy-MM-dd"
                                                            :allow-editing="true" alignment="center" :visible="true" header-cell-template="stDteTemplate"/>                                           
                                        </DxColumn>

                                        
                                        <DxColumn data-field="initReqWhDte" caption="Inspec. Date" width="12%"
                                            data-type="date" format="yyyy-MM-dd" :allow-editing="true" alignment="center" :visible="true"
                                            header-cell-template="inspDteTemplate" />
                                          

                                        <template #inspDteTemplate>
                                            <div>Inspec.<br />Date</div>
                                        </template>
                                        <template #sortOutTemplate>
                                            <div>Sorting<br />Out</div>
                                        </template>
                                        <template #stDteTemplate>
                                            <div>Ready<br />Stand by</div>
                                        </template>

                                        <DxColumn data-field="pntCd" caption="Paint Code" width="8%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true"
                                            header-cell-template="PaintCode" />

                                        <template #PaintCode>
                                            <div>Paint<br />Code<br/>(In-Out)</div>
                                        </template>

                                        <DxColumn data-field="wrkScp" caption="Work Scope" width="10%" data-type="string"
                                            :allow-editing="locVis" alignment="center" :visible="true" header-cell-template="wrkScpTemplate">  
                                            <DxLookup :data-source="locCdList" display-expr="name" value-expr="cd" />
                                        </DxColumn>   
                                            
                                        <template #wrkScpTemplate>
                                                <div>Work<br/>Scope</div>
                                        </template>

                                        <DxColumn caption="Fabrication Location" width="8%"
                                            data-type="string" :allow-editing="locVis" alignment="center" 
                                            header-cell-template="locCdTemplate" >
                                            <DxColumn data-field="locCd" caption="Location" width="8%"
                                                data-type="string" :allow-editing="locVis" alignment="center"  >  
                                                <DxLookup :data-source="locCdList" display-expr="name" value-expr="cd" />
                                            </DxColumn>                                              
                                        </DxColumn>

                                        <DxColumn caption="Fabrication Location" width="8%"
                                            data-type="string" :allow-editing="locVis" alignment="center" >
                                            <DxColumn data-field="locCd2" caption="Location" width="8%"
                                                data-type="string" :allow-editing="locVis" alignment="center"  >                                            
                                                <DxLookup :data-source="fnlocNoList" display-expr="name" value-expr="cd" />
                                            </DxColumn>        
                                        </DxColumn>

                                        <template #locCdTemplate>
                                            <div>Fabrication<br/>Location</div>
                                        </template>                                       
                                       
                                        <DxColumn data-field="locNop" caption="Paint Location" width="10%" data-type="string" :allow-editing="locVis"
                                            alignment="center" :visible="true"> 
                                            <DxLookup :data-source="locCdList" display-expr="name" value-expr="cd" />
                                        </DxColumn>                                           
                                                                            
                                        <template #locNopTemplate>
                                            <div>Paint<br />Location</div>
                                        </template>
                                       
                                        <DxPaging :enabled="true" :page-size="18" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import {DxLookup} from 'devextreme-vue/data-grid'
import { epms9010DetailList, epms9010fabSetStatus, epms9010DelFabDte } from '@/api/view/hip/90/epms9010Detail.js'
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { getNumComma, getStringToDate } from '@/utils/common.js'
import notify from 'devextreme/ui/notify' // message
import { getCmChildCode } from '@/api/system/cmCodeManage'

export default {
    name: 'epms9010Detail',
    mixins: [baseview, BaseDataGrid],
    components: {	
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox,
        DxLookup
    },
    data() {
        return {
            gridMainList: [],
            epms9010DetailRef: "epms9010DetailRef",
            selectedShip: '',
            shipNoList: [],

            selectedPor: 'All',
            porList: [],

            selectedBlock: 'All',
            blockList: [],

            //setDate: '',

            stDte: '',

            fnlocNoList: [],
            locCdList:[],

            locVis: false,

            div: {
                select: { name: 'Dist. Drawing', cd: '8' },
                items: [
                    { name: 'Dist. Drawing', cd: '8' }
                ]
            },

            makeSta: {
                select: { name: 'Not yet start', cd: '0' },
                items: [
                    { name: 'Not yet start', cd: '0' }
                ]
            },

             makeLoc: {
                select: { name: '', cd: 'A' },
                items: [
                    { name: '', cd: 'A' }
                ]
            }
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms9010DetailRef)
        },
    },
    methods: {
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        formatPrice(value) {
            return getNumComma(value)
        },
        async getInitList() {
            try {
                this.openLoading('searching')
                let params = {
                    code: '',
                    codegr: '',
                    prtCode: 'MAKE_STAT',
                    userFlag: 'Y',
                }
                let params2 = {
                    code: '',
                    codegr: '',
                    prtCode: 'DIV_9010',
                    userFlag: 'Y'
                }

                let params3 = {
                    code: '',
                    codegr: '',
                    prtCode: 'LOC_9010',
                    userFlag: 'Y'
                }

                let params4 = {
                    code: '',
                    codegr: '',
                    prtCode: 'FNLOC_NO',
                    userFlag: 'Y'
                }

                let params5 = {
                    code: '',
                    codegr: '',
                    prtCode: 'MAKE_LOC',
                    userFlag: 'Y'
                }

                await getCmChildCode(params).then(res => {
                    res.list.forEach(e => {
                        if (e.code !== '0') {
                            this.makeSta.items.push({ name: e.codeName, cd: e.code })
                        }
                    });
                })

                getCmChildCode(params2).then(res => {
                    res.list.forEach(e => {
                        this.div.items.push({ name: e.codeName, cd: e.code })
                    });
                })

                getCmChildCode(params3).then(res => {
                    res.list.forEach(e => {
                        this.locCdList.push({ name: e.codeName, cd: e.code })
                    });
                    this.locCdList.push({name: '', cd: ''})
                })

                getCmChildCode(params4).then(res => {
                    res.list.forEach(e => {
                        this.fnlocNoList.push({ name: e.codeName, cd: e.code })
                    });
                    this.fnlocNoList.push({ name: '', cd: '' })
                })

                 await getCmChildCode(params5).then(res => {
                    res.list.forEach(e => {                    
                        this.makeLoc.items.push({ name: e.codeName, cd: e.code })                        
                    });
                })

            } finally {
                this.endLoading()
            }
        },
        shipNoChange(e) {

            this.porList = [],
            this.blockList = [],

            this.getPorList()
            this.getBlockList()

        },

        btnRetrieve() {
            if (!this.selectedShip) {
                this.vToastify(this.$t('Ship no is not selected.'), 'warn')
                return
            }

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                makeStatus: this.makeSta.select.cd,            
            }
            console.log(params)
            await epms9010DetailList(params).then(res => {
                //this.gridMainList = res.list
                let list = []
                let cnt = 1;
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, rnum: e.rnum, selChek: 'N', shipNo: e.shipNo,                 block: e.block, mact: e.mact,
                            partNo: e.partNo, matlUnit: e.matlUnit, partQty: e.partQty, partUnitWgt: e.partUnitWgt,
                            psdDt: e.psdDt, distDwgDte: e.distDwgDte, cutDte: e.cutDte, weldDte: e.weldDte,
                            stPaintDte: e.stPaintDte, sortDte: e.sortDte, initReqWhDte: e.initReqWhDte,
                            pntCd: e.pntCd, wrkScp: e.wrkScp, locCd: e.locCd, locCd2: '' , locNop: e.locNop
                            
                        },
                        {
                            id: cnt++, rnum: e.rnum, selChek: 'N', shipNo: e.porNo + '-' + e.porSeq, block: e.block, mact: e.bomSerno,
                            partNo: e.partSpec, matlUnit: e.partSpec, partQty: e.partSpec, partUnitWgt: e.partSpec,
                            psdDt: e.whReqDte, distDwgDte: e.distDwgDte, cutDte: e.fitDte, weldDte: e.grindDte,
                            stPaintDte: e.edPaintDte, sortDte: e.sbyDte, initReqWhDte: e.initReqWhDte,
                            pntCd: e.pntCd, wrkScp: e.wrkScp, locCd: '',   locCd2: e.fnlocNo, locNop: e.locNop
                        },
                    )
                });
                this.gridMainList = list


            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },

        async getShipNoList() {
            let params = {
                makerCd: this.$store.state.user.makerCd
            }

            await getShipNoList1(params).then(res => {
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
            })
        },

        async getPorList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_por_no(params).then(res => {
                this.porList.push('All')
                res.list.forEach(e => {
                    this.porList.push(e.porNo)
                });
            })
        },

        async getBlockList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_block(params).then(res => {
                this.blockList.push('All')
                res.list.forEach(e => {
                    this.blockList.push(e.block)
                });
            })
        },       
        async btnSave() {
            var as_cut_dte, as_fit_dte, as_grind_dte, as_weld_dte, as_st_paint_dte, as_ed_paint_dte               
            let make_loc = this.makeLoc.select.cd
            var as_dist_dwg_dte, as_init_req_wh_dte, as_wrk_scp, as_fnloc_no, as_loc_cd, as_sort_dte
            let set_status
            let makerCd   = this.$store.state.user.makerCd
            let userId    = this.$store.state.user.userId
            let as_divDte = this.div.select.cd
            let as_shipNo, as_porNo, as_porSeq, as_mact, as_bomSerno, as_locNop            
            let params = []

            switch (this.makeSta.select.cd) {
                case '0':
                    set_status = '1'
                     break;
                case '1':
                    set_status = '2'
                     break;
                case '2':
                    set_status = '3'
                     break;
                case '3':
                    set_status = '4'
                     break;
                case '4':
                    set_status = '5'
                    break;
                default:
                    set_status = '1'
                    break;
            }

            if ( set_status === '1' && make_loc === 'A' && ( makerCd === '90263' || makerCd === '95987' || makerCd === '11728' )) 
            {
                this.vToastify(this.$t('Please choose Making Location.'), 'warn')
                return           
            }

            if (this.gridMainList.length > 0) {
                await this.gridMainInstance.saveEditData()
                var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
                
                if (!selectedMainRows.length) {
                    this.vToastify(this.$t('Data is not selected.'), 'warn')
                    return
                }
                
                for (let i = 0; i < selectedMainRows.length; i++) {
                    let j = selectedMainRows[i].id - 1
                    if (j >= 0) {
                        if (selectedMainRows[i].id % 2 !== 0) {
                            //console.log(i)                       
                                as_cut_dte = this.gridMainList[j].cutDte
                                as_weld_dte = this.gridMainList[j].weldDte
                                as_st_paint_dte = this.gridMainList[j].stPaintDte
                                as_sort_dte = this.gridMainList[j].sortDte
                                as_dist_dwg_dte = this.gridMainList[j].distDwgDte
                                as_init_req_wh_dte = this.gridMainList[j].initReqWhDte
                                as_wrk_scp = this.gridMainList[j].wrkScp
                                as_loc_cd = this.gridMainList[j].locCd
                                as_shipNo = this.gridMainList[j].shipNo
                                as_mact = this.gridMainList[j].mact
                                as_locNop = this.gridMainList[j].locNop

                                as_bomSerno = this.gridMainList[j + 1].mact
                                as_fit_dte = this.gridMainList[j + 1].cutDte
                                as_grind_dte = this.gridMainList[j + 1].weldDte
                                as_ed_paint_dte = this.gridMainList[j + 1].stPaintDte
                                as_fnloc_no = this.gridMainList[j + 1].locCd2
                                as_porNo = this.gridMainList[j + 1].shipNo.slice(0, 8)
                                as_porSeq = this.gridMainList[j + 1].shipNo.slice(9, 11)

                                if ((as_dist_dwg_dte > ' ' && as_cut_dte > ' ') && (new Date(as_dist_dwg_dte) > new Date(as_cut_dte))) {
                                    this.vToastify(this.$t('Please check Distribute Drawing date! ( Distribute Drawing date has to <= Cutting date)'), 'warn')
                                    return;
                                }
                                else if ((as_cut_dte > ' ' && as_fit_dte > ' ') && (new Date(as_cut_dte) > new Date(as_fit_dte))) {
                                    this.vToastify(this.$t('Please check Cutting date! (Cutting date has to <= Fitting Date)'), 'warn')
                                    return;
                                }
                                else if ((as_fit_dte > ' ' && as_weld_dte > ' ') && (new Date(as_weld_dte) < new Date(as_fit_dte))) {
                                    this.vToastify(this.$t('Please check Welding date! (Welding date has to >= Fitting Date)'), 'warn')
                                    return;
                                }
                                else if ((as_weld_dte > ' ' && as_grind_dte > ' ') && (new Date(as_weld_dte) > new Date(as_grind_dte))) {
                                    this.vToastify(this.$t('Please check Grind date! (Grinding date has to >= Welding Date)'), 'warn')
                                    return;
                                }

                                else if ((as_grind_dte > ' ' && as_st_paint_dte > ' ') && (new Date(as_grind_dte) > new Date(as_st_paint_dte))) {
                                    this.vToastify(this.$t('Please check Shot date! (Shot Start has to >= Make Finish Date)'), 'warn')
                                    return;
                                }
                                else if ((as_st_paint_dte > ' ' && as_ed_paint_dte > ' ') && (new Date(as_st_paint_dte) > new Date(as_ed_paint_dte))) {
                                    this.vToastify(this.$t('Please check Paint date! (Paint date has to >= Shot Date)'), 'warn')
                                    return;
                                }
                                else if ((as_sort_dte > ' ' && as_ed_paint_dte > ' ') && (new Date(as_sort_dte) < new Date(as_ed_paint_dte))) {
                                    this.vToastify(this.$t('Please check Sorting date! (Sorting date has to >= Paint Finish Date)'), 'warn')
                                    return;
                                }
                                else if ((as_init_req_wh_dte > ' ' && as_ed_paint_dte > ' ') && (new Date(as_init_req_wh_dte) < new Date(as_ed_paint_dte))) {
                                    this.vToastify(this.$t('Please check Inspection date! (Inspection date has to >= Paint Finish Date)'), 'warn')
                                    return;
                                }
                                console.log('fit ' + as_fit_dte)
                                console.log('weld ' + as_weld_dte)
                                console.log('grind ' + as_grind_dte)
                                params.push({
                                    shipNo: as_shipNo,
                                    porNo: as_porNo,
                                    porSeq: as_porSeq,
                                    mact: as_mact,
                                    bomSerno: as_bomSerno,
                                    makeStatus: set_status,
                                    divDte: as_divDte,
                                    cutDte: !as_cut_dte ? '' : as_cut_dte,
                                    fitDte: !as_fit_dte ? '' : as_fit_dte,
                                    weldDte: !as_weld_dte ? '' : as_weld_dte,
                                    grindDte: !as_grind_dte ? '' : as_grind_dte,
                                    stPaintDte: !as_st_paint_dte ? '' : as_st_paint_dte,
                                    edPaintDte: !as_ed_paint_dte ? '' : as_ed_paint_dte,
                                    sortDte: !as_sort_dte ? '' : as_sort_dte,
                                    dwgDte: !as_dist_dwg_dte ? '' : as_dist_dwg_dte,
                                    initReqWhDte: !as_init_req_wh_dte ? '' : as_init_req_wh_dte,
                                    wrkScp: !as_wrk_scp ? '' : as_wrk_scp,
                                    fnlocNo: !as_fnloc_no ? '' : as_fnloc_no,
                                    locCd: !as_loc_cd ? '' : as_loc_cd,
                                    makeLoc: make_loc,
                                    locNop: !as_locNop ? '' : as_locNop,
                                    userId: userId
                                })
                                

                            }                        

                    }
                }
                                                                                                         
                 console.log(params)
                 
                    this.openLoading('searching')
                   
                    epms9010fabSetStatus(params).then(res => {
                        //console.log(res.body)
                        if (res.body === 'OK') {
                            notify(this.$t('Save data is completed.'), 'success', 3000)
                        } else {
                            this.vToastify(this.$t('An error has been occured while saving data. ' + res.body ), 'warn')
                        }
                    })
                        .catch(error => {
                            this.vToastify(error, 'warn')
                        })
                        .finally(() => {
                            this.gridMainInstance.clearSelection()
                            this.btnRetrieve()
                        })                                
            }


        },

        async goSetDte() {

            let set_opt = this.div.select.cd
            let set_dte = this.stDte
            let bf_dte 
            let make_status = this.makeSta.select.cd

            await this.gridMainInstance.saveEditData()
            var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
            // console.log(selectedMainRows)            
            //console.log(set_opt + '-' + make_status)  
            if (!selectedMainRows.length) {
                 this.vToastify(this.$t('Data is not selected.'), 'warn')
                return                                                     
            } else {
                for (let i = 0; i < selectedMainRows.length; i++) {                
                        let list = selectedMainRows[i]
                        let j = selectedMainRows[i].id - 1
                    if (j >= 0) {
                        if (set_opt === '8') {
                            this.gridMainList[j].distDwgDte = set_dte
                        } else if (set_opt === '7') {
                            this.gridMainList[j].initReqWhDte = set_dte
                        } else {
                            if (set_opt === '0' && make_status === '0') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    this.gridMainList[j].cutDte = set_dte
                                }
                            }
                            if (set_opt === '1' && make_status === '1') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    bf_dte = this.gridMainList[j].cutDte
                                    if (new Date(bf_dte) <= new Date(set_dte)) {
                                        this.gridMainList[j + 1].cutDte = set_dte
                                    }
                                }
                            }
                            if (set_opt === '2' && make_status === '1') {
                                if (selectedMainRows[i].id % 2 === 0) {
                                    bf_dte = this.gridMainList[j].cutDte
                                    if (new Date(bf_dte) <= new Date(set_dte)) {
                                        this.gridMainList[j - 1].weldDte = set_dte
                                    }
                                }
                            }
                            if (set_opt === '3' && make_status === '1') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    bf_dte = this.gridMainList[j].weldDte
                                    if (new Date(bf_dte) <= new Date(set_dte)) {
                                        this.gridMainList[j + 1].weldDte = set_dte
                                    }
                                }
                            }
                            if (set_opt === '4' && make_status === '2') {
                                if (selectedMainRows[i].id % 2 === 0) {
                                    bf_dte = this.gridMainList[j].weldDte
                                    if (new Date(bf_dte) <= new Date(set_dte)) {
                                        this.gridMainList[j - 1].stPaintDte = set_dte
                                    }
                                }
                            }
                            if (set_opt === '5' && make_status === '3') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    bf_dte = this.gridMainList[j].stPaintDte
                                    if (new Date(bf_dte) <= new Date(set_dte)) {
                                        this.gridMainList[j + 1].stPaintDte = set_dte
                                    }
                                }
                            }
                            if (set_opt === '6' && (make_status === '4' || make_status === '3')) {
                                if (selectedMainRows[i].id % 2 === 0) {
                                    bf_dte = this.gridMainList[j].stPaintDte
                                    if (new Date(bf_dte) <= new Date(set_dte)) {
                                        this.gridMainList[j - 1].sortDte = set_dte
                                    }
                                }
                            }
                        }        
                    }                        
                 
                 //}                    

                }
            }
            
        },
        async goClearDte() {

            let set_opt = this.div.select.cd           
            let make_status = this.makeSta.select.cd

            await this.gridMainInstance.saveEditData()
            var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
            if (!selectedMainRows.length) {
                 this.vToastify(this.$t('Data is not selected.'), 'warn')
                return

            } else {
                for (let i = 0; i < selectedMainRows.length; i++) {                   
                    let list = selectedMainRows[i]
                    let j = selectedMainRows[i].id - 1
                    if (j >= 0) { 

                        if (set_opt === '8') {
                            this.gridMainList[j].distDwgDte = ''
                        } else if (set_opt === '7') {
                            this.gridMainList[j].initReqWhDte = ''
                        } else {
                            if (set_opt === '0' && make_status === '0') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    this.gridMainList[j].cutDte = ''
                                }
                            }
                            if (set_opt === '1' && make_status === '1') {
                                if (selectedMainRows[i].id % 2 === 0) {
                                    this.gridMainList[j].cutDte = ''
                                }
                            }
                            if (set_opt === '2' && make_status === '1') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    this.gridMainList[j].weldDte = ''
                                }
                            }
                            if (set_opt === '3' && make_status === '1') {
                                if (selectedMainRows[i].id % 2 === 0) {
                                    this.gridMainList[j].weldDte = ''
                                }
                            }
                            if (set_opt === '4' && make_status === '2') {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    this.gridMainList[j].stPaintDte = ''

                                }
                            }
                            if (set_opt === '5' && make_status === '3') {
                                if (selectedMainRows[i].id % 2 === 0) {
                                    this.gridMainList[j].stPaintDte = ''
                                }
                            }
                            if (set_opt === '6' && (make_status === '4' || make_status === '3')) {
                                if (selectedMainRows[i].id % 2 !== 0) {
                                    this.gridMainList[j].sortDte = ''
                                }
                            }
                        }

                    }                                                        
                }
            }
            
        },

        async goDeleteDte() {
        
            await this.gridMainInstance.saveEditData()
            var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
            let param = []
            // console.log(selectedMainRows)            
            //console.log(set_opt + '-' + make_status)  
            if (!selectedMainRows.length) {
                this.vToastify(this.$t('Data is not selected.'), 'warn')
                return                                                     
            } else {
                for (let i = 0; i < selectedMainRows.length; i++) {                   
                    let list = selectedMainRows[i]
                    let j = selectedMainRows[i].id - 1
                    if (j >= 0) {   
                        if (selectedMainRows[i].id % 2 !== 0) {
                            param.push({
                                shipNo   : this.gridMainList[j].shipNo,
                                porNo    : this.gridMainList[j + 1].shipNo.slice(0, 8),
                                porSeq   : this.gridMainList[j + 1].shipNo.slice(9, 11),
                                mact     : this.gridMainList[j].mact,
                                bomSerno : this.gridMainList[j + 1].mact
                            })
                        }                                              
                    }                                                        
                }
                console.log('Del Select : ', param)

                this.openLoading('searching')
                   
                epms9010DelFabDte(param).then(res => {
                        //console.log(res.body)
                        if (res.body === 'OK') {
                            notify(this.$t('Delete all fabrication date is completed.'), 'success', 3000)
                        } else {
                            this.vToastify(this.$t('An error has been occured while delete. ' + res.body ), 'warn')
                        }
                    })
                        .catch(error => {
                            this.vToastify(error, 'warn')
                        })
                        .finally(() => {
                            this.gridMainInstance.clearSelection()
                            this.btnRetrieve()
                        })                           
            }

            },

        async onValueChanged(value, cellInfo) {            
            // for (let i = 0; i < this.gridMainList.length; i++) {                
            //         if (i % 2 === 0) {
            //             if (value.value === true) {
            //                 this.gridMainList[i].selChek = 'Y'
            //             } else {
            //                 this.gridMainList[i].selChek = 'N'
            //             }
            //         }               
            // }
            for (let i = 0; i < this.gridMainList.length; i++) {                              
                    this.gridMainList[i].selChek = value.value
                    if (value.value === true) {
                        this.gridMainInstance.selectRows(i, true)
                        this.gridMainInstance.selectRows([i + 1], true)
                        this.gridMainList[i].selChek = 'Y'                     
                    } else {
                        this.gridMainInstance.deselectAll()  
                        this.gridMainList[i].selChek = 'N'
                    }                                  
            }
            this.gridMainInstance.updateDimensions()
        },
        onValueChanged2(value, cellInfo) {           
            // if (cellInfo.data.selChek == 'N') {
            //     this.gridMainList[cellInfo.data.id].selChek = 'Y'
            // } else {
            //     this.gridMainList[cellInfo.data.id].selChek = 'N'
            // }
            //console.log(cellInfo.component)
             cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
            if (cellInfo.value === 'N') {
                cellInfo.component.selectRows([cellInfo.row.key], true)
                cellInfo.component.selectRows([cellInfo.row.key + 1], true)
            } else {
                cellInfo.component.deselectRows([cellInfo.row.key], true)
                cellInfo.component.deselectRows([cellInfo.row.key + 1], true)
            }
            cellInfo.component.updateDimensions()
        },
        //cell merge
        cellPrepared(e) {
            if (e.rowType === 'data') {
                if (e.column.name === 'selChek' || e.column.caption === 'Block' || e.column.caption === 'DWG Date' || e.column.caption === 'Inspec. Date' || 
                    e.column.caption === 'Paint Code' || e.column.caption === 'Work Scope' || e.column.caption === 'Paint Location') {
                    if (e.rowIndex % 2 === 0) {
                        e.cellElement.setAttribute('rowspan', 2)
                    } else {
                        e.cellElement.style.display = 'none'
                    }
                }
                
                if (e.column.caption === 'Part Specification' && Number(e.rowIndex) % 2 !== 0) {

                    if (e.columnIndex === 4) {
                        e.cellElement.setAttribute('colspan', 4)
                    } else if (e.columnIndex === 5 || e.columnIndex === 6 || e.columnIndex === 7) {
                        e.cellElement.style.display = 'none'
                    }
                    //console.log(e)                  
                }

                if(Number(e.rowIndex) % 2 === 0){

                    if (e.column.dataField === 'locCd' && e.columnIndex === 17 ) {
                        e.cellElement.setAttribute('colspan', 2)                    
                    } else if (e.column.dataField === 'locCd2' && e.columnIndex === 18) {
                        e.cellElement.style.display = 'none'
                    }

                } else {
                     if (e.column.dataField === 'locCd2' && e.columnIndex === 18 ) {
                        e.cellElement.setAttribute('colspan', 2)                    
                    } else if (e.column.dataField === 'locCd' && e.columnIndex === 17) {
                        e.cellElement.style.display = 'none'
                    }
                }
                               

            } else if (e.rowType === 'header') {
                if (e.column.caption === 'Part Specification') {
                    if(e.columnIndex === 2){
                        e.cellElement.setAttribute('colspan', 4)
                    } else if (e.columnIndex === 3 || e.columnIndex === 4 || e.columnIndex === 5) {
                        e.cellElement.style.display = 'none'
                    }                    
                }  
                if (e.column.caption === 'Fabrication Location' && e.columnIndex === 17) {                    
                    e.cellElement.setAttribute('colspan', 2)
                    e.cellElement.setAttribute('rowspan', 2)
                } else if (e.column.caption === 'Fabrication Location' && e.columnIndex === 18) {
                    e.cellElement.style.display = 'none'
                }

                 if (e.column.caption === 'Location' && e.columnIndex === 11) {                    
                     e.cellElement.style.display = 'none'
                } else if (e.column.caption === 'Location' && e.columnIndex === 12) {
                    e.cellElement.style.display = 'none'
                }
                                               
            }
        }

    },
    mounted() {
        //var date = new Date();
        //this.setDate = new Date(date.getFullYear(), date.getMonth(), 1)        
        let toDay = new Date
        toDay.setDate(toDay.getDate());
        this.stDte = toDay

        let makerCd = this.$store.state.user.makerCd

        if ( makerCd === '90263' || makerCd === '95987' || makerCd === '11728' ) {
            this.locVis = true
        } else {
            this.locVis = false
        }

        this.getShipNoList()
        this.getInitList()
        this.gridMainInstance.option('defaultPaging', false)
    }
}

</script>

<style scoped></style>